
import { Component,Prop,Watch, BaseMixins, TabRoute } from '@/lib';

import appConfig from '@/config'
import { arrayHelper,menuRouteHelper } from '@/lib/utils';
import { Menu } from '@/types/iview/menu';
import beforeClose from '@/router/before-close'


@Component
export default class TagsNav extends BaseMixins {
    name:string='TagsNav';
    
    tagBodyLeft:number = 0;
    rightOffset:number =  40;
    outerPadding:number = 4;
    contextMenuLeft:number =  0;
    contextMenuTop:number =  0;
    visible:boolean =  false;
    homeName:string = appConfig.homeName;
    menuList:any = {
        others:string =>'关闭其他',
        all:string => '关闭所有'
    };
    @Prop({type:Array,default:[]}) list:Array<TabRoute>;
    @Prop({type:Object}) value:any;

    // annotate refs type.
    // The symbol `!` (definite assignment assertion)
    // is needed to get rid of compilation error.
    $refs!: {
        scrollOuter: any,
        scrollBody:any,
        tagsPageOpened:any
    }
    refsTag!:Array<any>

    get currentRouteObj () {
      const { name, params, query,meta } = menuRouteHelper.getMenuRoute(this.value)
      //const { name, params, query,meta } = this.value;
      return { name, params, query,meta }
    }

    handlescroll (e) {
      var type = e.type
      let delta = 0
      if (type === 'DOMMouseScroll' || type === 'mousewheel') {
        delta = (e.wheelDelta) ? e.wheelDelta : -(e.detail || 0) * 40
      }
      this.handleScroll(delta)
    };

    handleScroll (offset) {
      const outerWidth = this.$refs.scrollOuter.offsetWidth
      const bodyWidth = this.$refs.scrollBody.offsetWidth
      if (offset > 0) {
        this.tagBodyLeft = Math.min(0, this.tagBodyLeft + offset)
      } else {
        if (outerWidth < bodyWidth) {
          if (this.tagBodyLeft < -(bodyWidth - outerWidth)) {
            this.tagBodyLeft = this.tagBodyLeft
          } else {
            this.tagBodyLeft = Math.max(this.tagBodyLeft + offset, outerWidth - bodyWidth)
          }
        } else {
          this.tagBodyLeft = 0
        }
      }
    };

    handleTagsOption (type) {
      if (type.includes('all')) {
        // 关闭所有，除了home
        let res = this.list.filter(item => item.name === appConfig.homeName)
        this.$emit('on-close', res, 'all')
      } else if (type.includes('others')) {
        // 关闭除当前页和home页的其他页
        let res = this.list.filter(item => menuRouteHelper.routeEqual(this.currentRouteObj, item.menuRoute) || item.name === appConfig.homeName)
        this.$emit('on-close', res, 'others', this.currentRouteObj)
        setTimeout(() => {
          this.getTagElementByRoute(this.currentRouteObj)
        }, 100)
      }
    };

    handleClose (current) {
      let currentMenuRoute = current.menuRoute;

      if (currentMenuRoute.meta && currentMenuRoute.meta.beforeCloseName && currentMenuRoute.meta.beforeCloseName in beforeClose) {
        new Promise(beforeClose[currentMenuRoute.meta.beforeCloseName]).then(close => {
          if (close) {
            this.close(currentMenuRoute)
          }
        })
      } else {
        this.close(currentMenuRoute)
      }
    };

    close (route) {
      let res = this.list.filter(item => !menuRouteHelper.routeEqual(route, item.menuRoute))
      this.$emit('on-close', res, undefined, route)
    };

    handleClick (item:TabRoute) {
      this.$emit('input', item)
    };

    // showTitleInside (item) {
    //   return menuRouteHelper.showTitle(item, this)
    // }

    showTitleInside(item){
      return this.L(item.meta.title);
    }

    isCurrentTag (item) {
      return menuRouteHelper.routeEqual(this.currentRouteObj, item.menuRoute)
    }

    moveToView (tag) {
      const outerWidth = this.$refs.scrollOuter.offsetWidth
      const bodyWidth = this.$refs.scrollBody.offsetWidth
      if (bodyWidth < outerWidth) {
        this.tagBodyLeft = 0
      } else if (tag.offsetLeft < -this.tagBodyLeft) {
        // 标签在可视区域左侧
        this.tagBodyLeft = -tag.offsetLeft + this.outerPadding
      } else if (tag.offsetLeft > -this.tagBodyLeft && tag.offsetLeft + tag.offsetWidth < -this.tagBodyLeft + outerWidth) {
        // 标签在可视区域
        this.tagBodyLeft = Math.min(0, outerWidth - tag.offsetWidth - tag.offsetLeft - this.outerPadding)
      } else {
        // 标签在可视区域右侧
        this.tagBodyLeft = -(tag.offsetLeft - (outerWidth - this.outerPadding - tag.offsetWidth))
      }
    }

    getTagElementByRoute (route) {
      // let tabRoute = menuRouteHelper.getTabRoute(route);
      this.$nextTick(() => {
        this.refsTag = this.$refs.tagsPageOpened
        this.refsTag.forEach((item, index) => {
          if (menuRouteHelper.routeEqual(route, item.$attrs['data-route-item'])) {
            let tag = this.refsTag[index].$el
            this.moveToView(tag)
          }
        })
      })
    }

    contextMenu (item, e) {
      if (item.name === appConfig.homeName) {
        return
      }
      this.visible = true
      const offsetLeft = this.$el.getBoundingClientRect().left
      this.contextMenuLeft = e.clientX - offsetLeft + 10
      this.contextMenuTop = e.clientY - 64
    }

    closeMenu () {
      this.visible = false
    }

    @Watch('$route')
    routeChange(to) {
      this.getTagElementByRoute(to)
    }
    @Watch('visible')
    visibleChange (value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }

    mounted () {
        setTimeout(() => {
            this.getTagElementByRoute(this.$route)
        }, 200)
    }
}
